<template>
    <div class="section card-slider2" id="card-slider2">
      <div class="card" v-for="item in departments" v-bind:key="item.id">
        <div class="row">
          <div class="col-4 overflow-hidden p-3">
            <img :src="item.image" class="card-slider2__img" alt="">
            <!-- <img src="/images/img3.jpg" class="card-slider2__img" alt=""> -->
          </div>
          <div class="col-8 py-3 pr-3">
            <h3>{{item.name}}</h3>
            <p class="small">Опубликовано курсов: {{ item.published_courses.length }}</p>
            <p class="small">
                <router-link :to="{ name: 'department_show', params: { id: item.id } }">Перейти</router-link>
            </p>
          </div>
        </div> 
      </div>
    </div>
</template>

<script>

import jQuery from 'jquery'
import 'lightslider'

export default {

    props: {
        departments: Array,
    },

    mounted() {

        jQuery('#card-slider2').lightSlider({
            item: 3,
            autoWidth: false,
            slideMove: 1, // slidemove will be 1 if loop is true
            slideMargin: 30,
            loop: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        item: 2,
                        slideMargin: 20
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        item: 1,
                        slideMargin: 10,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        item: 1,
                    }
                }
            ]
        });

    }
    
}
</script>



<style scoped>


.card-slider2__img {
    object-fit: cover;

    /* background: url('../images/img2.jpg') center center; */
    max-width: 100%;
    max-height: 100%;

}



</style>


